import styled from 'styled-components';
import { getColor, px2rem } from '../../../../stylesheets/tools';

const StyledEducationRefinementSearch = styled.div`
  .search__input-wrapper {
    color: ${getColor('darkGray')};
    background-color: transparent;
    background-image: linear-gradient(180deg, currentColor, currentColor),
      linear-gradient(225deg, currentColor, currentColor),
      linear-gradient(0deg, currentColor, currentColor),
      linear-gradient(90deg, currentColor, currentColor),
      linear-gradient(135deg, transparent 6px, currentColor 6px, currentColor 8px, transparent 8px);
    background-position: top right, top right, bottom left, bottom left, top left;
    background-size: calc(100% - 8px) 2px, 2px 100%, 100% 2px, 2px calc(100% - 8px), 10px 10px;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    position: relative;

    input {
      padding: ${px2rem('20px')} ${px2rem('40px')} ${px2rem('20px')} ${px2rem('40px')};
      position: relative;
      display: block;
      width: 100%;
      background: none;
      border: none;
      z-index: 1;
      font-size: ${px2rem('16px')};
      outline: 0;

      &::-webkit-search-cancel-button {
        display: none;
      }
    }
    .search__input-icon {
      position: absolute;
      left: ${px2rem('8px')};
      color: #000;
    }
    .search__input-reset {
      position: absolute;
      right: ${px2rem('12px')};
      z-index: 1;
    }
  }
`;

export default StyledEducationRefinementSearch;
